import { Round } from "@/models/round"
import { MarketConditionsEvent, EnergyHeadlinesEvent, TurnEvent } from "@/models/events"
import { Dispatch } from "@/models/dispatch"

const r1Price = 500
const r2Availability = 30
const r3Price = 400
const r4Availability = 30
const r5price = 1200
const r5Availability = 15

const r1MinUnits = 100
const r2MinUnits = 300
const r3MinUnits = 1000
const r4MinUnits = 2500
const r5MinUnits = 5000

const overStart = new Dispatch("overviewStart", null)

export async function rounds() {
    return [
        new Round(
            [
                new MarketConditionsEvent("r1mc", [overStart]),
                new EnergyHeadlinesEvent("r1eh", [r1Price], [new Dispatch("setPrice", { id: 4, price: r1Price }), overStart]),
                new TurnEvent("r1tn", [r1MinUnits], [new Dispatch("setMinMwatts", r1MinUnits)])
            ],
            r1MinUnits
        ),
        new Round(
            [
                new MarketConditionsEvent("r2mc", [new Dispatch("setPrice", { id: 6, price: 900 }), overStart]),
                new EnergyHeadlinesEvent("r2eh", [r2Availability], [new Dispatch("setAmount", { id: 3, amount: r2Availability }), overStart]),
                new TurnEvent("r2tn", [r2MinUnits], [new Dispatch("setMinMwatts", r2MinUnits)])
            ],
            r2MinUnits
        ),
        new Round(
            [
                new MarketConditionsEvent("r3mc", [new Dispatch("setPrice", { id: 4, price: 1100 }), overStart]),
                new EnergyHeadlinesEvent("r3eh", [r3Price], [new Dispatch("setPrice", { id: 6, price: r3Price }), overStart]),
                new TurnEvent("r3tn", [r3MinUnits], [new Dispatch("setMinMwatts", r3MinUnits)])
            ],
            r3MinUnits
        ),
        new Round(
            [
                new MarketConditionsEvent("r4mc", [new Dispatch("setPrice", { id: 8, price: 4000 }), new Dispatch("setPrice", { id: 6, price: 600 }), new Dispatch("setPrice", { id: 5, price: 100 }), overStart]),
                new EnergyHeadlinesEvent("r4eh", [r4Availability], [new Dispatch("setAmount", { id: 1, amount: r4Availability }), overStart]),
                new TurnEvent("r4tn", [r4MinUnits], [new Dispatch("setMinMwatts", r4MinUnits)])
            ],
            r4MinUnits
        ),
        new Round(
            [
                new MarketConditionsEvent("r5mc", [new Dispatch("setPrice", { id: 9, price: 3000 }), overStart]),
                new EnergyHeadlinesEvent("r5eh", [r5price, r5Availability], [new Dispatch("setPrice", { id: 4, price: r5price }), new Dispatch("setAmount", { id: 4, amount: r5Availability }), overStart]),
                new TurnEvent("r5tn", [r5MinUnits], [new Dispatch("setMinMwatts", r5MinUnits)])
            ],
            r5MinUnits
        )
    ]
}
